import React, { useState, useEffect } from "react";
import { PortalComponent, ModalComponent, CardComponent, TableComponent, ButtonIconComponent, SelectComponent, ButtonActionComponent } from '../../../components/pages/index'
import { useGetApiWs } from "../../../hooks";
import { api, apiConfig } from "../../../util/api";
import Swal from "sweetalert2";
const AssignAttributes = props => {

    const urlCustomer = useGetApiWs('admin', 'entity', 'customer-get');
    const urlCategoryFeature = useGetApiWs('admin', 'entity', 'category-feature');
    const urlCustomerSave = useGetApiWs('admin', 'entity', 'customer-save');
    const urlCustomerDelete = useGetApiWs('admin', 'entity', 'customer-delete');

    const [studies, setStudies] = useState([]);
    const [lbStudy, setLbStudy] = useState(null);
    const [categories, setCategories] = useState([]);
    const [lbCategorie, setLbCategorie] = useState([]);
    const [attributes, setAttributes] = useState([]);
    const [atrributesRemaining, setAttributesRemaning] = useState([]);
    const [lbAttributesRemaining, setLbAttributesRemaning] = useState([]);

    const fetchCustomersStudies = async () => {
        const req = await api().post(urlCustomer, { type_info: 'studies', customer_id: props.companyId }, apiConfig());
        var options = req.data.response.map((obj) => {
            var rObj = {};
            rObj['value'] = obj.study_type_id;
            rObj['label'] = obj.study_type_name;
            return rObj;
        });
        setStudies(options);
    }

    const fecthCustomerCategories = async (studiesId) => {
        const req = await api().post(urlCustomer, { type_info: `categories`, study_id: studiesId, customer_id: props.companyId }, apiConfig());
        var options = req.data.response.map((obj) => {
            var rObj = {};
            rObj['value'] = obj.category_id;
            rObj['label'] = obj.category_name;
            rObj['idStudy'] = obj.study_type_id;
            return rObj;
        });
        setCategories(options);
    }

    const fetchCustomersAttributes = async (studiesId, categoryId) => {
        const req = await api().post(urlCustomer, { type_info: `attributes`, study_id: studiesId, category_id: categoryId, customer_id: props.companyId }, apiConfig());
        var options = req.data.response;
        setAttributes(options)
    }

    const fetchCustomersAttributesRemaining = async (studiesId, categoryId) => {
        const req = await api().post(urlCategoryFeature, { study_id: studiesId, category_id: categoryId, customer_id: props.companyId }, apiConfig());
        var options = req.data.response.map((obj) => {
            var rObj = {};
            rObj['value'] = obj.feature_type_id;
            rObj['label'] = obj.feature_type_name;
            return rObj;
        });
        setAttributesRemaning(options);
    }

    //GUARDAR
    const fetchCustomerSave = async () => {
        const params = {};
        params['type_info'] = 'attributes';
        params['study_id'] = lbStudy.value;
        params['category_id'] = lbCategorie.value;
        params['feature_id'] = lbAttributesRemaining.value;
        params['customer_id'] = props.companyId;
        await api().post(urlCustomerSave, params, apiConfig());
        fetchCustomersAttributes(lbStudy.value, lbCategorie.value);
        fetchCustomersAttributesRemaining(lbStudy.value, lbCategorie.value);
        setLbAttributesRemaning([]);
    }

    const StudyChange = async vals => {
        setLbStudy(vals);

        if (vals == null) {
            setCategories([]);
        } else {
            fecthCustomerCategories(vals.value);
            setLbCategorie(vals.label)
        }
    }

    const CategoriesChange = async vals => {
        setLbCategorie(vals);
        if (vals != null) {
            fetchCustomersAttributes(vals.idStudy, vals.value);
            fetchCustomersAttributesRemaining(vals.idStudy, vals.value);
            setAttributesRemaning(vals.value)
        }
    }

    const AtrributesRemainingChange = async vals => {
        setLbAttributesRemaning(vals)
    }

    const fetchEliminar = async (id) => {
        const req = await api().post(urlCustomerDelete, { type_info: 'attributes', customer_category_feature_id: id }, apiConfig());
        fetchCustomersAttributes(lbStudy.value, lbCategorie.value);
        fetchCustomersAttributesRemaining(lbStudy.value, lbCategorie.value);
        Swal.fire({
            position: 'center-end',
            icon: 'success',
            title: 'Se eliminó correctamente',
            showConfirmButton: false,
            timer: 1000
          })
    }

    const tbHeadings = ['id', 'code']
    const tbColumns = [
        //{ name: 'ID', selector: row => row.feature_type_id },
        { name: 'ATRIBUTOS', selector: row => row.feature_type_name },
        { name: 'ELIMINAR', button: true, cell: row => <BtnOptsDelete customerCategoryFeaturesId={row.customer_category_feature_id}></BtnOptsDelete>, allowOverflow: false, style: { position: 'relative', overflow: 'visible' } }
    ]

    const BtnOptsDelete = (props) => {
        return (
            <div>
                <ButtonIconComponent icon="trash" onClick={() => { fetchEliminar(props.customerCategoryFeaturesId) }} className="bg-red-500 p-2 m-1 rounded-md text-white"></ButtonIconComponent>
            </div>
        )
    }
    useEffect(() => {
        fetchCustomersStudies();
    }, []);

    return (
        <PortalComponent>
            <ModalComponent header={"ASIGNAR ATRIBUTOS"} onCloseModal={props.closeModal}>
                <div className="grid md:grid-cols-2 lg:grid-cols-2 gap-4">
                    <div className="grid grid-cols-1 gap-4 content-start">
                        <SelectComponent label="ESTUDIOS" options={studies} value={lbStudy} onChange={StudyChange} class={`sm:order-1`} />
                        <SelectComponent label="CATEGORIAS" options={categories} value={lbCategorie} onChange={CategoriesChange} class={`sm:order-2`} />
                        <SelectComponent label="ATRIBUTOS RESTANTES" options={atrributesRemaining} value={lbAttributesRemaining} onChange={AtrributesRemainingChange} />
                        <div className="row-span-2 mt-6">
                            <ButtonActionComponent name="Agregar" onClick={fetchCustomerSave} />
                        </div>
                    </div>
                    <div className="row-span-3 mt-5 mr-10 md:order-3 order-4">
                        <CardComponent header={<h3>LISTADO DE ATRIBUTOS</h3>}>
                            <TableComponent
                                keyField="customer_category_features_id"
                                columns={tbColumns}
                                headItem={tbHeadings}
                                data={attributes}
                                highlightOnHover={true}
                            />
                        </CardComponent>
                    </div>
                </div>

            </ModalComponent>
        </PortalComponent>
    )
}
export default AssignAttributes